import React from 'react';
import { assertNotNil } from '../../utils/types';
import { ISvgIconProps } from './types';
import LetterIcon from './LetterIcon';
import IndexedIcon from './IndexedIcon';

type IOmitedSvgName = Omit<ISvgIconProps, 'name'>;

interface ICohortConditionIconProps extends IOmitedSvgName {
  conditionIndex: number;
}

// renders cohort condition index icon (1, 2, 3)

export const CohortConditionIcon = ({
  conditionIndex,
  isActive,
  ...props
}: ICohortConditionIconProps) => {
  assertNotNil(conditionIndex);

  return (
    <IndexedIcon
      {...props}
      name="named-cohort"
      positiveIndex={conditionIndex + 1}
      isActive={isActive || true}
    />
  );
};

interface IPredictionCohortIconProps extends IOmitedSvgName {
  index: number;
}

const predictionCohortLetters = ['S', 'T'];

// renders cohort prediction icon based on index - source or target

export const PredictionCohortIcon = ({
  index,
  isActive,
  ...props
}: IPredictionCohortIconProps) => {
  const letter = predictionCohortLetters[index];

  assertNotNil(letter);

  return (
    <LetterIcon
      {...props}
      name="named-cohort"
      letter={letter}
      isActive={isActive || true}
    />
  );
};
